<template>

     <div class="link-container">
      <a href="https://shimo.im/sheets/m4kMMZ7r1LCWVKkD/XPLdO" target="_blank" class="link link-primary">浙商</a>
      <a href="https://gtjafxgl.feishu.cn/wiki/P8iNwNPLxiUbgakkyoJcYdCNn6d" target="_blank" class="link link-primary">国君</a>
      <a href="https://galaxyderivatives.feishu.cn/sheets/SVy2sNldHh5zIhtZfBHc9X1ln0c" target="_blank" class="link link-primary">银河</a>
      <a href="https://www.kdocs.cn/l/cgYgJIqIMsMK" target="_blank" class="link link-primary">光大</a>
    </div>
    <h1>上传文件</h1>
    <div class="drop-area card" :class="{ 'drag-over': isDragging }" @dragenter.prevent="dragEnter" @dragleave.prevent="dragLeave" @drop.prevent="handleDrop">
      <div class="drop-message">
        <p v-if="!isDragging">将文件拖放到此处或点击选择文件</p>
        <p v-else>释放文件以上传</p>
      </div>
      <input
        type="file"
        @change="handleFileChange"
        multiple
        ref="fileInput"
        class="file-input"
      />
    </div>
    <div v-if="files.length" class="file-list">
      <div v-for="(file, index) in files" :key="index" class="file-item">
        <span>{{ file.name }}</span>
        <button @click="removeFile(index)" class="btn btn-danger btn-small">移除</button>
      </div>
    </div>
    <button v-if="files.length" @click="uploadFiles" class="btn btn-primary upload-button">上传</button>
    <div v-if="uploadStatus" class="upload-status" :class="uploadStatus.type">
      <p>{{ uploadStatus.message }}</p>
    </div>


    <div class="form-container">
      <label class="label">选择日期:</label>
      <input
        type="date"
        v-model="date"
        class="date-picker"
        @change="fetchData"
      />
    </div>
    <div class="button-container">
        <button @click="processData" class="btn btn-primary update-stock-button">
          <span class="btn-icon">✏️</span> 处理数据
        </button>
        <button @click="deleteData" class="btn btn-danger update-stock-button">
          <span class="btn-icon">🗑️</span> 删除数据
        </button>
        <button @click="updateStock" class="btn btn-success update-stock-button">
          <span class="btn-icon">🔄</span> 更新标的
        </button>
        <button @click="hot_list" class="btn btn-warning hot-list-button">
          <span class="btn-icon">🏆</span> 生成龙虎榜
        </button>
        <button @click="text_list" class="btn btn-info text-list-button">
          <span class="btn-icon">📄</span> 生成文本
        </button>
        <button @click="etf_list" class="btn btn-primary etf-list-button">
          <span class="btn-icon">💰</span> 生成ETF
        </button>
        <button @click="day_search" class="btn btn-success day-search-button">
          <span class="btn-icon">⬆️</span> 涨停入库
        </button>
        <button @click="export2Db" class="btn btn-danger export2db-button">
          <span class="btn-icon">⬇️</span> 龙虎榜(游资)
        </button>
        <button @click="merge_excel_file" class="btn btn-info text-list-button">
          <span class="btn-icon">⬇️</span> 合并文件
        </button>
    </div>

</template>

<script>
import axios from 'axios';
import { formatDate } from '@/utils/commonMethods';

export default {
  name: 'ToolsPage',
  components: {},
  data() {
    return {
      date: new Date(),
      files: [],
      uploadStatus: null,
      isDragging: false,
      questionQuery: '',
      stockData: null,
      wcData: null,
      wencaiData: null
    };
  },
  computed: {
    formattedDate() {
      return this.date ? formatDate(this.date) : '';
    },
  },
  methods: {
    // 显示消息提示
    showMessage(message, type = 'success') {
      const msg = document.createElement('div');
      msg.className = `message-toast message-toast-${type}`;
      msg.textContent = message;
      msg.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 12px 20px;
        border-radius: 4px;
        color: white;
        z-index: 9999;
        animation: slideIn 0.3s ease;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      `;
      
      if (type === 'success') {
        msg.style.backgroundColor = '#67c23a';
      } else if (type === 'error') {
        msg.style.backgroundColor = '#f56c6c';
      } else if (type === 'warning') {
        msg.style.backgroundColor = '#e6a23c';
      } else if (type === 'info') {
        msg.style.backgroundColor = '#909399';
      }
      
      document.body.appendChild(msg);
      
      setTimeout(() => {
        msg.style.animation = 'slideOut 0.3s ease';
        setTimeout(() => {
          document.body.removeChild(msg);
        }, 300);
      }, 3000);
    },
    async export2Db() {
      console.log('开始请求数据:', this.questionQuery);
      try {
        const responses = await axios.get(`/api/export2db`);
        const responseData = responses.data;
        this.stockData = responseData;
        this.showMessage(responseData.data, 'success');
        console.log('所有请求完成:', this.stockData); // 添加调试信息
      } catch (error) {
        this.showMessage('请求失败: ' + error, 'error');
        console.error('请求失败:', error);
      }
    },
    async merge_excel_file() {
      console.log('开始合并请求:', this.questionQuery);
      try {
        const responses = await axios.post(`/api/merge-excel`);
        const responseData = responses.data.message;
        this.showMessage(responseData.length + '条', 'success');
        console.log('所有请求完成:',responseData); // 添加调试信息
      } catch (error) {
        this.showMessage('请求失败: ' + error, 'error');
        console.error('请求失败:', error);
      }
    },
    async day_search() {
      try {
        const response = await axios.get(`/api/day_search`);
        const responseData = response.data;
        if (responseData.data == 0) {
          this.showMessage('没有找到相关数据', 'error');
        } else {
          this.showMessage('操作成功,新增数据:' + responseData.data + '条', 'success');
        }
      } catch (error) {
        console.error('数据获取失败:', error);
        this.showMessage('数据获取失败，请检查网络连接或服务器状态。' + error, 'error');
      } finally {
        console.log('请求完成');
      }
    },
    async processData() {
      console.log('开始请求数据:', this.questionQuery);
      try {
        const now_date = this.date;
        console.log('当前时间:', now_date);
        const responses = await axios.get(`/api/processData`, { params: { now_date: this.formattedDate } });
        const data = responses.data;
        if (data) {
          this.showMessage(JSON.stringify(data.is_ok), 'success');
          this.showMessage(JSON.stringify(data.error), 'error');
        }

      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    async deleteData() {
      console.log('开始请求数据:', this.questionQuery);
      try {
        const now_date = this.date;
        console.log('当前时间:', now_date);
        const responses = await axios.get(`/api/deleteData`, { params: { now_date: this.formattedDate } });
        const responseData = responses.data;
        console.info(responseData);
        this.showMessage(responseData.message, 'success');
        console.log('所有请求完成:', responseData); // 添加调试信息
      } catch (error) {
        console.error('请求失败:', error);
        this.showMessage(error.response.data.detail, 'error');
      }
    },
    async updateStock() {
      try {
        const response = await axios.get(`/api/update_stock_list`);
        this.wcData = response.data;
        const responseData = response.data;
        this.showMessage(responseData.data, 'success');
        console.info(this.wcData);
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    async hot_list() {
      try {
        const response = await axios.get(`/api/hot_list`);
        this.wencaiData = response.data;
        console.info(this.wencaiData);
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    async text_list() {
      console.log('开始请求数据:', this.questionQuery);
      try {
        const responses = await axios.get(`/api/text_list`);
        const responseData = responses.data;
        this.wencaiData = responseData;
        console.log('所有请求完成:', this.wencaiData); // 添加调试信息
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    async etf_list() {
      console.log('开始请求数据:', this.questionQuery);
      try {
        const responses = await axios.get(`/api/etf_list`);
        const responseData = responses.data;
        this.stockData = responseData;
        console.log('所有请求完成:', this.stockData); // 添加调试信息
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    handleFileChange(event) {
      this.files = Array.from(event.target.files);
    },
    handleDrop(event) {
      this.files = Array.from(event.dataTransfer.files);
      this.isDragging = false;
    },
    dragEnter() {
      this.isDragging = true;
    },
    dragLeave() {
      this.isDragging = false;
    },
    // 获取数据方法，响应日期变化
    fetchData() {
      console.log('日期变更:', this.date);
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    async uploadFiles() {
      if (this.files.length === 0) {
        this.uploadStatus = { type: 'error', message: '请选择一个文件' };
        return;
      }

      const formData = new FormData();
      this.files.forEach((file) => {
        formData.append('files', file); // 修改这里
      });

      try {
        const response = await axios.post('/api/upload_file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${this.$store.getters.token}`
          },
        });
        this.uploadStatus = {
          type: 'success',
          message: `文件上传成功: ${response.data.filenames.join(', ')}`,
        };
        this.files = [];
      } catch (error) {
        this.uploadStatus = { type: 'error', message: `文件上传失败: ${error.message}` };
        if (error.response && error.response.data && error.response.data.detail) {
          this.uploadStatus.message += ` - ${error.response.data.detail}`;
        }
      }
    },
  },
};
</script>

<style scoped>
.tools-page {
  margin: 20px;
}

/* 卡片样式 */
.card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  margin-top: 20px;
}

.card-content {
  padding: 24px;
}

/* 上传容器样式 */
.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.link-container {
  margin-bottom: 20px;
}

.link {
  margin-right: 10px;
  font-weight: bold;
  color: #409EFF;
  text-decoration: none;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s;
}

.link:hover {
  color: #66b1ff;
  background-color: #ecf5ff;
}

.link-primary {
  color: #409EFF;
}

h1 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}

.drop-area {
  width: 100%;
  max-width: 400px;
  min-height: 200px;
  border: 2px dashed #409EFF;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s;
  background-color: white;
}

.drop-area.drag-over {
  border-color: #66b1ff;
  background-color: #ecf5ff;
}

.drop-message {
  text-align: center;
  color: #666;
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.file-list {
  width: 100%;
  max-width: 400px;
  margin-top: 20px;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.upload-button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #409EFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.upload-button:hover {
  background-color: #66b1ff;
}

/* 按钮样式 */
.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
}

.btn {
  padding: 10px 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: white;
  color: #606266;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
  outline: none;
  display: flex;
  align-items: center;
  gap: 5px;
}

.btn:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.btn-primary {
  background-color: #409eff;
  border-color: #409eff;
  color: white;
}

.btn-primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
  color: white;
}

.btn-success {
  background-color: #67c23a;
  border-color: #67c23a;
  color: white;
}

.btn-success:hover {
  background-color: #85ce61;
  border-color: #85ce61;
  color: white;
}

.btn-danger {
  background-color: #f56c6c;
  border-color: #f56c6c;
  color: white;
}

.btn-danger:hover {
  background-color: #f78989;
  border-color: #f78989;
  color: white;
}

.btn-warning {
  background-color: #e6a23c;
  border-color: #e6a23c;
  color: white;
}

.btn-warning:hover {
  background-color: #ebb563;
  border-color: #ebb563;
  color: white;
}

.btn-info {
  background-color: #909399;
  border-color: #909399;
  color: white;
}

.btn-info:hover {
  background-color: #a6a9ad;
  border-color: #a6a9ad;
  color: white;
}

.btn-small {
  padding: 6px 12px;
  font-size: 12px;
}

/* 上传状态样式 */
.upload-status {
  margin-top: 20px;
  padding: 12px;
  border-radius: 4px;
  text-align: center;
}

.upload-status.success {
  background-color: #f0f9eb;
  color: #67c23a;
  border: 1px solid #e1f3d8;
}

.upload-status.error {
  background-color: #fef0f0;
  color: #f56c6c;
  border: 1px solid #fbc4c4;
}

/* 表单样式 */
.form-container {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.label {
  font-weight: 500;
  color: #606266;
}

.date-picker {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
}

/* 图标样式 */
.btn-icon {
  font-size: 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .button-container {
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
    justify-content: center;
  }
  
  .form-container {
    flex-direction: column;
    align-items: flex-start;
  }
}



/* 按钮间距样式 */
.day-search-button,
.export2db-button,
.text-list-button,
.update-stock-button,
.hot-list-button,
.etf-list-button {
  margin-bottom: 10px;
}

/* 动画效果 */
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

/* 消息提示样式 */
.message-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 4px;
  color: white;
  z-index: 9999;
  animation: slideIn 0.3s ease;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.message-toast-success {
  background-color: #67c23a;
}

.message-toast-error {
  background-color: #f56c6c;
}

.message-toast-warning {
  background-color: #e6a23c;
}

.message-toast-info {
  background-color: #909399;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .tools-page {
    margin: 10px;
  }
  
  .card-content {
    padding: 16px;
  }
  
  .buttons, .button-container {
    flex-direction: column;
    gap: 12px;
  }
  
  button, .btn {
    width: 100%;
    justify-content: center;
  }
  
  .container {
    padding: 10px;
  }

  .form-container {
    margin-bottom: 10px;
  }

  .button-group {
    flex-direction: row;
    gap: 10px;
    display: flex;
  }
}
</style>
